import React from 'react';

import Bg1 from '../images/bg_section1.svg'

// import Image from '../images/'

const HomeProjects = (props) => {
  return (
    <div className="HomeWrapper" >
    	<div className="bg" style={{background: props.bg }}></div>
    	<div className="BgSection">
    		<img src={props.bgImage} alt=""/>
    	</div>
    	<div className="ContentsContainer IndexStyle">
    		<div className={props.className}>
    			<div className="FeaturedInfo">
    				<h2>{props.title}</h2>
    				<h3>{props.work}</h3> 
    				<p>{props.text}</p>
    			</div>
    			<div className="FeaturedMedia">
    				<figure>
    					<img src={props.image} alt=""/>
    				</figure>
    			</div>
    		</div>
    		{ props.commentAuthor ? (
	    			<div className="IndexComment">
			    		<figure className="comment-author-profile">
			    			<img src={props.commentAuthorProfile} alt=""/>
			    		</figure>
		    			<h2>{props.commentAuthor}</h2>
		    			<p>{props.commentAuthorText}</p>
		    		</div>
		      ) : (
		        console.log("no hay datos")
			)}
    		
    	</div>
    </div>
  )
}

export default HomeProjects;


// WEBPACK FOOTER //
// ./src/components/home-projects.js